import { MedicationIndicatorNames, MedicationRisk } from "pokal_api"
import Accordion from "./Accordion"
import { useEffect, useState } from "react"
import { splitBasicMedicationEntries, SplitMeds } from "../util/medIsCoMed"

interface MedicationRiskComponentProps {
    risk: MedicationRisk
}

function MedicationRiskComponent(props: MedicationRiskComponentProps) {

    function getDescription(): string {
        let description = MedicationIndicatorNames[props.risk.indicator].description
        for (let i = 0; i < props.risk.args.length; ++i) {
            const arg = props.risk.args[i]
            description = description.replace("%ARG%", arg)
        }
        return description
    }


    // Function to render text with clickable links
    function renderWithLinks(text: string | undefined) {
        if (!text) return null;
        
        // Process the text paragraph by paragraph
        return text.split('\n').map((paragraph, paragraphIndex) => {
            // For each paragraph, process links
            const parts = [];
            let lastIndex = 0;
            const regex = /\[([^\]]+)\]\(([^)]+)\)/g;
            let match;
            
            while ((match = regex.exec(paragraph)) !== null) {
                // Add the text before the link
                if (match.index > lastIndex) {
                    parts.push(paragraph.substring(lastIndex, match.index));
                }
                
                // Add the link component
                const linkText = match[1];
                const linkUrl = match[2];
                parts.push(
                    <a 
                        key={`link-${paragraphIndex}-${match.index}`} 
                        href={linkUrl} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline"
                    >
                        {linkText}
                    </a>
                );
                
                lastIndex = match.index + match[0].length;
            }
            
            // Add any remaining text after the last link
            if (lastIndex < paragraph.length) {
                parts.push(paragraph.substring(lastIndex));
            }
            
            // Return the complete paragraph with its links
            return <p key={`paragraph-${paragraphIndex}`} className="my-0">{parts}</p>;
        });
    }

    const [splitMeds, setSplitMeds] = useState<SplitMeds>(splitBasicMedicationEntries(
        props.risk.causingMedication
    ))

    useEffect(() => {
        setSplitMeds(splitBasicMedicationEntries(
            props.risk.causingMedication
        ))
    }, [props.risk])

    return (
        <Accordion risk={true} key={props.risk.id} title={MedicationIndicatorNames[props.risk.indicator].title}>
            <>
                <div className={"mt-3"}>
                    {getDescription()}
                </div>
                {MedicationIndicatorNames[
                    props.risk.indicator
                    ].recommendation && (
                    <div className={"mt-3 flex space-y-1 flex-col"}>
                        <div className={"font-bold"}>
                            Empfehlung:
                        </div>
                        <div>
                            {renderWithLinks(MedicationIndicatorNames[props.risk.indicator].recommendation)}
                        </div>
                    </div>
                )}
                {props.risk.causingMedication.length > 0 && (
                    <div className={"flex space-x-1"}>
                        <div className={"flex-1"}>
                            <div
                                className={
                                    "font-bold mt-8"
                                }>
                                Verantwortliche Antidepressiva
                            </div>
                            {splitMeds.antidepressants.length > 0 ? (
                                <>
                                    {
                                        splitMeds.antidepressants.map(
                                            (m) => {
                                                //console.log(m); // Print antidepressants to console
                                                return (
                                                    <div key={m.atc}>
                                                        {m.name}
                                                    </div>
                                                );
                                            }
                                        )
                                    }
                                </>
                            ) : (
                                <div className={"italic"}>Keine Antidepressiva verantwortlich.</div>
                            )}
                        </div>
                        <div className={"flex-1"}>
                            <div
                                className={
                                    "font-bold mt-8"
                                }>
                                Verantwortliche Komedikation
                            </div>
                            {splitMeds.co.length > 0 ? (
                                <>
                                    {
                                        splitMeds.co.map(
                                            (m) => {
                                                //console.log(m); // Print co-medication to console
                                                return (
                                                    <div key={m.atc}>
                                                        {m.name}
                                                    </div>
                                                );
                                            }
                                        )
                                    }
                                </>
                            ) : (
                                <div className={"italic"}>Keine Komedikation verantwortlich.</div>
                            )}
                        </div>
                    </div>
                )}
            </>
        </Accordion>
    )
}

export default MedicationRiskComponent
